
import { defineComponent, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import InnerLink from "../InnerLink/index.vue"

interface IframeView {
  path: string
  meta: {
    link: string
  }
  query: Record<string, string>
}

export default defineComponent({
  components: { InnerLink },
  setup() {
    const store = useStore()
    const route = useRoute()
    
    const iframeViews = computed<IframeView[]>(() => store.state.tagsView.iframeViews)
    
    const iframeUrl = (url: string, query: Record<string, string>) => {
      if (Object.keys(query).length > 0) {
        const params = Object.keys(query).map((key) => key + "=" + query[key]).join("&")
        return url + "?" + params
      }
      return url
    }
    
    return {
      iframeViews,
      iframeUrl,
      route
    }
  }
})
